module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"startFilling":"Assess"},"es":{"fieldName":"Evaluar"},"sw":{"fieldName":"Tathmini"}}')
  delete Component.options._Ctor
}
